import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    COPY_USER_CPD_ACTIVITY: (previousUserId, newUserId) => ({ previousUserId, newUserId }),
    API: {
        COPY_USER_CPD_ACTIVITY: apiResourceActionCreator('copyResult')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/user/copyUserCpdActivity`, authToken, payload, actions.admin.api.copyUserCpdActivity);

function* copyUserCpdActivity(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'copyUserCpdActivity',
  action: actions,
  sagas: copyUserCpdActivity,
  reducers: {
    request: (state, action) => ({
      ...state,
      isCopyingActivity: true,
      copyResult: null,
      error: null,
    }),
    success: (state, action) => ({
      ...state,
      isCopyingActivity: false,
      copyResult: action.payload.copyResult,
      error: null,
    }),
    failed: (state, action) => ({
      ...state,
      isCopyingActivity: false,
      copyResult: null,
      error: action.payload.error,
    })
  }
}

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/copyUserCpdActivity.js